import { motion } from "framer-motion";
import styles from "../styles/index";
import { fadeIn, staggerContainer } from "../utils/motion";
import { useTranslation } from "react-i18next";
import village1 from "../public/village1.png";
import { TitleText, TypingText } from "../components/customText";
import { villageOptions } from "../constants";
const Village = () => {
  const { t } = useTranslation();

  return (
    <section className={`${styles.paddings}`}>
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
        className={`${styles.innerWidth} flex lg:flex-row flex-col gap-8 `}
      >
        <motion.div
          variants={fadeIn("right", "tween", 0.2, 1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          className={` ${styles.flexCenter} flex-1 `}
        >
          <img src={village1} alt="villge1" className="w-full rounded-[40px]" />
        </motion.div>
        <motion.div
          variants={fadeIn("left", "tween", 0.3, 1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          className="flex flex-1 justify-center flex-col"
        >
          <div className="flex flex-col ">
            <TypingText title={t("hajijA")} textStyles="text-center" />
            <div className={`${styles.about} dark:text-[#c7c7c7]`}>
              {t("hajijAbout")}
            </div>
            <div className="flex flex-col max-w-[370px] ">
              {villageOptions.map((option) => (
                <div
                  className={`${styles.flexCenter} flex-row`}
                  key={option.number}
                >
                  <div
                    className={`${styles.flexCenter} w-[60px] h-[60px] rounded-[24px] bg-[#323F5D] mt-5`}
                  >
                    <p className="font-bold text-[20px] text-white">
                      {option.number}{" "}
                    </p>
                  </div>
                  <p className="flex-1 mx-[30px] pt-5 font-normal text-[18px] dark:text-[#B0B0B0] leading-[32.4px] self-center">
                    {t(option.option)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Village;
